module.exports = __webpack_public_path__ + "img/stq.d47ac366.png";